export default {"src":"/_next/static/media/gray-download.12d18b89.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};